import { createFileRoute } from '@tanstack/react-router';

import BillingPage from '~/app/settings/billing/BillingPage';

export const Route = createFileRoute('/_app/settings/billing')({
	beforeLoad: () => {
		return {
			getTitle: 'Billing'
		};
	},
	component: BillingPage
});
